import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Jeff Anders
 * id 1E12551C-392F-43A2-8C18-BFDBC24307A5
 * name invoice-text-arrow-left-outline
 * version: 7.4.47
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/invoice-text-arrow-left-outline.svg
 * tags
 * - Banking 
 * - Shopping 
 */
export const InvoiceTextArrowLeftOutlineIcon = createSvgIcon(<><path d="M13.3 20.86L12 20L9 22L6 20L3 22V3H21V13.34C20.37 13.12 19.7 13 19 13V5H5V18.26L6 17.6L9 19.6L12 17.6L13.04 18.29C13 18.5 13 18.76 13 19C13 19.65 13.1 20.28 13.3 20.86M17 7V9H7V7H17M15 11V13H7V11H15M18 18V16L15 19L18 22V20H22V18H18Z" /></>, 'InvoiceTextArrowLeftOutlineIcon');
export default InvoiceTextArrowLeftOutlineIcon